import { IPage, PageType, createPage, generatePageGrids } from "@dataone/lib";
import { useMutation } from "@tanstack/react-query";
import { Button, Form, Input, Select } from "antd";
import { styled } from "styled-components";

interface PageFormProps {
  handleCancel: () => void;
  dashboardId: string;
  handleOnSuccess: (message: string) => void;
}

const PageForm = ({
  handleCancel,
  dashboardId,
  handleOnSuccess,
}: PageFormProps) => {
  const { Option } = Select;
  const [pageForm] = Form.useForm();
  const { mutate: addPage } = useMutation(createPage);
  const handleFormConfirm = (page: IPage) => {
    addPage(
      {
        dashboardId,
        page: { ...page, grid: generatePageGrids(page.type) },
      },
      {
        onSuccess: (res) => {
          handleOnSuccess(res.message);
        },
      }
    );
  };
  return (
    <StyledDashboardForm>
      <Form layout="vertical" form={pageForm} onFinish={handleFormConfirm}>
        <Form.Item
          rules={[
            {
              whitespace: true,
              required: true,
              message: "Please input the page name",
            },
          ]}
          name="name"
          label={<StyledLabel>Page Name</StyledLabel>}
        >
          <Input maxLength={255} />
        </Form.Item>
        <Form.Item
          rules={[
            {
              required: true,
              message: "Please select the page type",
            },
          ]}
          name="type"
          className="second-input"
          label={<StyledLabel>Type</StyledLabel>}
        >
          <Select getPopupContainer={(trigger) => trigger.parentNode}>
            <Option value={PageType.PORTRAIT}>Portrait</Option>
            <Option value={PageType.LANDSCAPE}>Landscape</Option>
          </Select>
        </Form.Item>
        <StyledFooterButtons>
          <Button className="cancel-button" onClick={handleCancel}>
            Cancel
          </Button>
          <Button className="ok-button" htmlType="submit">
            OK
          </Button>
        </StyledFooterButtons>
      </Form>
    </StyledDashboardForm>
  );
};

export default PageForm;

const StyledFooterButtons = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  .ok-button {
    border-radius: 10px;
    background: #4974f6;
    color: #fff;
    &:hover {
      background: #4974f6;
      color: #fff !important;
    }
  }
  .cancel-button {
    border-radius: 10px;
    background: #eff1fd;
    color: #000;
    border: none;
    &:hover {
      background: #eff1fd;
      color: #000 !important;
      border: none !important;
    }
  }
`;
const StyledDashboardForm = styled.div`
  // width: 400px;
  width: 280px;
  padding: 100px 0px;
  .ant-input,
  .ant-select-selector {
    display: flex;
    margin-inline: auto;
    border-radius: 10px;
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
    // border: 1px solid #757682 !important;
    background: #fff;
    height: 40px !important;
    align-items: center;
  }
  .ant-form-item-explain-error {
    font-size: 12px;
  }

  .second-input {
    .ant-form-item-explain-error {
      margin-top: 10px !important;
    }
  }

  .ant-select-single {
    height: auto !important;
  }
`;
const StyledLabel = styled.div`
  color: #040726;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: -0.27px;
`;
